<template>
    <div
        class="walletInterest padded-page"
        :class="{
            none: status === 'none',
        }"
        ref="screenWrapper"
    >
        <template v-if="status === 'high'">
            <div class="mb-5 text-white font-satoshi_r">
                <p class="text-lg">You earned</p>
                <p class="text-4xl font-satoshi_b font-bold my-1">
                    <CountUpNumber :endVal="reviewData?.wallet_interest_ngn ?? 0" currency="₦" />
                </p>
                <p class="mb-4">In wallet interest from Sycamore in 2025.</p>
                <p>You earned</p>
                <div class="grid grid-cols-3 gap-4 my-2">
                    <div class="bg-yInRev-purple text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl">
                        {{ $format.renderCurrency(reviewData?.wallet_interest_usd, "compact", "USD") }}
                    </div>
                    <div class="bg-yInRev-purple text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl">
                        {{ $format.renderCurrency(reviewData?.wallet_interest_gbp, "compact", "GBP") }}
                    </div>
                    <div class="bg-yInRev-purple text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl">
                        {{ $format.renderCurrency(reviewData?.wallet_interest_eur, "compact", "EUR") }}
                    </div>
                </div>
                <p>on your FX balance.</p>
            </div>
            <p v-if="reviewData?.wallet_interest_ngn < 5000">
                Low balances = low wallet interest 😔. Keep your balance higher to earn daily returns . Get up to 10% p.a as interest on your wallet
                balance. Grow your wallet balance to maximize your interest earnings.
            </p>
        </template>
        <div v-else class="mb-5 text-white font-satoshi_r">
            <p class="mb-5">Low balances = low wallet interest 😔. Keep your balance higher to earn daily returns.</p>
            <p class="text-lg">Get up to</p>
            <p class="text-4xl font-satoshi_b font-bold my-2">10% p.a.</p>
            <p>
                as interest on your wallet balance. <br /><br />
                Grow your wallet balance to maximize your interest earnings.
            </p>
        </div>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        status() {
            if (this.reviewData?.wallet_interest_ngn <= 0) return "none";
            return "high";
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.walletInterest {
    color: white;
    min-height: 100vh;

    background-color: #7a44be;
    background-image: url("../../assets/images/year-in-review/wallet-interest.svg");
    background-size: auto 60%;
    background-repeat: no-repeat;
    background-position: bottom left;
}

.walletInterest.none {
    background-image: url("../../assets/images/year-in-review/wallet-interest-none.svg");
}

@media (max-height: 750px) {
    .walletInterest {
        background-size: auto 50%;
        background-position: bottom center;
    }
}
</style>
